import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { Partners, CreatePartner, UpdatePartner, PublishMessage, PartnerConfigurations } from './Interface/partner.i';
import { PartnersService } from '../../../core/routing/services/Partners_api/partners.service';
import { takeUntil } from 'rxjs/internal/operators/takeUntil';
import { Subject } from 'rxjs/internal/Subject';
import { GlobalConstants } from '../../../common/constants/global.constant';
import { PartnersConstants } from '../../../core/routing/services/Partners_api/constants/partners.constants';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { first } from 'rxjs/internal/operators/first';
import { environment } from '../../../../environments/environment';
import { GoogleAnalyticsService } from '../../google-analytics/google-analytics.service';
import moment from 'moment';
import { Utils } from 'src/app/common/utils/utils';
import { DataService } from '../../../core/data/data-service';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'iposcen-partners',
  templateUrl: './partners.component.html',
  styleUrls: ['./partners.component.scss']
})
export class PartnersComponent implements OnInit {
  @ViewChild('searchValue') animateThis: ElementRef;
  @ViewChild('createdTime') partnerCreatedTime: ElementRef;
  @ViewChild('partnerName') partnerNameSort: ElementRef;
  @ViewChild('updatedTime') partnerUpdatedTime: ElementRef;
  @ViewChild('acknowModal') acknowledgeModal: ElementRef;
  expanded: boolean[] = [];
  showDetails: boolean[] = [];
  showFrom: number;
  editTooltip = PartnersConstants.EDIT;
  showTo: number;
  maxSize = 5;
  displayPartnerData = [];
  buttonShow: boolean[] = [];
  partners: Partners[] = [];
  tableSize: number;
  searchData: string;
  page: number;
  partnerName: string;
  openModal = false;
  popuptext = PartnersConstants.POPUP_TEXT;
  allPartnerData: Partners[] = [];
  isExpanded: boolean;
  partnerForm: FormGroup;
  publishMessageForm: FormGroup;
  previousMessageForm: FormGroup;
  createPartnerResponse: CreatePartner[] = [];
  updatePartnerResponse: UpdatePartner[] = [];
  fileName: string;
  imageName: string;
  partnerData: any = {};
  showTypeError = false;
  showSizeError = false;
  uploadEdit = false;
  duplicatePartner = false;
  partnerId: string;
  imageData: any;
  fileType: string;
  file: File;
  imageUrl: any;
  baseAssetUrl = environment.apiBaseUrlAsset;
  showSearchDetails = false;
  partner: any = {};
  imageFile: File;
  searchNamePlaceHolderText = PartnersConstants.searchNamePlaceHolderText;
  partnerNamePlaceholder = PartnersConstants.PARTNERNAMEPLACEHOLDER;
  isPartnerDataEmpty: boolean;
  dataSearch: boolean;
  customExpiryDateResult: string;
  oemCheckPartnerCreation = GlobalConstants.OEM_CHECK_PARTNER_CREATION;
  showMessagePopup = false;
  isCustomExpiryDateCorrect = false;
  isCustomPublishTimeZoneSelected = false;
  isCustomExpiryTimeZoneSelected = false;
  editPublishDateInfo: string;
  customPublishDateResult: string;
  isSubmitted: boolean;
  isPublishDateCustomDatepicker = false;
  isCustomPublishDateCorrect: boolean;
  isExpiryDatePicker: boolean;
  isPublishExpiryNever = false;
  editexpiryDateInfo: string;
  isExpiredDateIncorrect: boolean;
  segmentsForm: FormGroup;
  isPublishedDateInCorrect: boolean;
  ispreviousmessage = false;
  isNewWindowOpen = false;
  isclearMessage = false;
  isPreviousWindowOpen = false;
  publishedDateTime: string;
  expiredOEMMsgTime: string;
  publishedBy: string;
  acknowlegementTitle: string;
  acknowlegementDesc: string;
  publishMessageToPartners = GlobalConstants.PUBLISH_MESSAGE_PARTNER;
  partnerMessage = GlobalConstants.PARTNER_MESSAGE;
  partnerNewMessage = GlobalConstants.PARTNER_NEW_MESSAGE;
  messageExpiration = GlobalConstants.PARTNER_EXPIRATION_MESSAGE;
  publishNewMessage = GlobalConstants.PUBLISH_NEW_MESSAGE;
  previousMessage = GlobalConstants.PARTNER_PREVIOUS_MESSAGE;
  clearPreviousMessage = GlobalConstants.PARTNER_CLEAR_MESSAGE;
  clearMessageFromOEM = GlobalConstants.PARTNER_CLEAR_PREVIOUS_MESSAGE;
  publishedByName = GlobalConstants.PARTNER_PUBLISHED_BY;
  clearMessageTooltip = GlobalConstants.CLEAR_MESSAGE_TOOLTIP;
  publishDateAndTime = GlobalConstants.MESSAGE_PUBLISH_DATETIME;
  expirationDateAndTime = GlobalConstants.MESSAGE_EXPIRATION_DATETIME;
  pushNewMessage = GlobalConstants.PUSH_NEW_MESSAGE;
  messagePublished = GlobalConstants.PARTNER_MESSAGE_PUBLISHED;
  publishMessageSuccess = GlobalConstants.PARTNER_PUBLISH_SUCCESS;
  messageCleared = GlobalConstants.PARTNER_MESSAGE_CLEARED;
  clearMessageSuccess = GlobalConstants.PARTNER_PUBLISH_CLEARED;
  private ngUnsubscribe = new Subject<boolean>();
  objArray: any = [];
  sortBy: string;
  sortOrder: string;  
  isUploadLogoTabActive = true;  
  videoFileType: string;
  videoFileName: string;
  isVideoTriggered = false;
  fileTypeError = false;
  videoLengthError = false;
  videoSizeError = false;
  videoFile: any;
  videoUrl: any;
  isVideo = false;
  imageType: string;
  editVideoFileType: string;
  editVideoFileName: string;
  editVideoFile: any;
  editFileTypeError = false;
  editVideoLengthError = false;
  editVideoSizeError = false;
  videoEditFlag = false;
  partnerVideosText = GlobalConstants.PARTNER_VIDEO_TEXT;
  partnerLogoMsg1 = GlobalConstants.PARTNER_LOGO_ERROR_MSG1;
  partnerLogoMsg2 = GlobalConstants.PARTNER_LOGO_ERROR_MSG2;
  editImageFlag = false;
  imageUploadedBy: string;
  constructor(private partnersService: PartnersService, 
              private formBuilder: FormBuilder, 
              private googleAnalyticsService: GoogleAnalyticsService, 
              private dataService: DataService,
              private sanitizer: DomSanitizer) { }
  ngOnInit(): void {
    this.customPublishDateResult = GlobalConstants.NOW;
    this.isExpiredDateIncorrect = false;
    this.isPublishDateCustomDatepicker = false;
    this.isCustomPublishDateCorrect = false;
    this.getAllPartnerData();
    this.createPartnerForm();
    this.createPublishForm();
    this.isExpiryDatePicker = false;
    this.isExpanded = false;
    this.page = 1;
    this.searchData = '';
    this.tableSize = 10;
    this.showFrom = ((this.page - 1) * this.tableSize) + 1;
    this.showTo = Math.min(this.page * this.tableSize);
  }

  openAcknowModal(modal: any) { modal.open(); }

  openCreateModal() {
    this.openModal = !this.openModal;
    this.fileName = '';
    this.imageName = '';
    this.showSizeError = false;
    this.showTypeError = false;
    this.duplicatePartner = false;
    this.isUploadLogoTabActive = true;
  }

  closeModal() {
    this.openModal = false;
    this.resetForm();
    this.fileName = '';
    this.imageName = '';
    this.showSizeError = false;
    this.duplicatePartner = false;
    this.showTypeError = false;
    this.videoFile = '';
    this.videoUrl = null;
  }

  getAllPartnerData() {
    this.partnersService.getAllPartners(PartnersConstants.UPDATED_TIME, PartnersConstants.DESC)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(getReviewPartnerResponse => {
        this.allPartnerData = (getReviewPartnerResponse.partner as Partners[]);
        this.showFrom = ((this.page - 1) * this.tableSize) + 1;
        this.showTo = Math.min(this.page * this.tableSize, this.allPartnerData.length);
        this.isPartnerDataEmpty = (this.allPartnerData.length === 0) || false;
        if (this.allPartnerData.length === 0) {
          this.showFrom = 0;
          this.showTo = 0;
        }
        this.displayPartnerData = [];
        this.allPartnerData.forEach(ele => {
          this.displayPartnerData.push(ele);
        });
        this.displayPartnerData.forEach(element => {
          if (element.partnerName) {
            element.isExpanded = false;
            element.isEdit = false;
          }
        });
      });
  }

  getDetailsOfPartners(id: string) {
    this.uploadEdit = false;
    this.videoEditFlag = false;
    this.editImageFlag = false;
    this.buttonShow[id] = !this.buttonShow[id];
    this.displayPartnerData.forEach(element => {
      if (element.partnerId === id) {
        element.isExpanded = !element.isExpanded;
        this.partnersService.getPartnerById(id)
          .pipe(takeUntil(this.ngUnsubscribe))
          .subscribe(getallpartnersResponse => {
            const configuration = getallpartnersResponse?.partner?.configurations;
            this.imageUploadedBy=getallpartnersResponse?.partner?.createdByUserId;
            element.imageUrl = this.baseAssetUrl + PartnersConstants.USERS + PartnersConstants.SLASH + getallpartnersResponse?.partner?.createdByUserId + PartnersConstants.PARTNERS + PartnersConstants.SLASH + element.partnerId;
            if (configuration?.includes('imgFileName')) {
              element.editImageName = JSON.parse(configuration)?.imgFileName;
              //element.imageUrl = this.baseAssetUrl + this.partnersService.putImageUrl + element.partnerId;
              if (JSON.parse(configuration)?.videoFileName) {
                element.editVideoName = JSON.parse(configuration)?.videoFileName;
                element.videoUrl = this.baseAssetUrl + this.partnersService.newPutImageUrl + element.partnerId + PartnersConstants.PARTNERVIDEO;
              }
            } else {
              element.editImageName = configuration;
              element.editVideoName = '';
              //element.imageUrl = this.baseAssetUrl + this.partnersService.putImageUrl + element.partnerId;
              element.videoUrl = '';
            }            
          });
        if (!element.isExpanded) {
          element.isEdit = false;
          this.uploadEdit = false;
        }
      } else {
        element.isExpanded = false;
      }
    });
  }

  checkAccordianOpen(id): boolean {
    let isValid = false;
    this.displayPartnerData.forEach(element => {
      if (element.partnerId === id) {
        if (element.isExpanded) {
          isValid = true;
        }
      }
    });

    return isValid;
  }

  editPartnerDetails(id: string) {
    this.duplicatePartner = false;
    this.displayPartnerData.forEach(element => {
      if (element.partnerId === id) {
        element.isEdit = true;
        if (element.isEdit) {
          this.uploadEdit = false;
        }
      }
    });
    if (!this.checkAccordianOpen(id)) {
      this.getDetailsOfPartners(id);
    }
  }

  getAllPartnersBySearch() {
    this.animateThis.nativeElement.blur();
    this.partnersService.getAllPartnersBySearch(this.animateThis.nativeElement.value)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(getallPartnerResponse => {
        if (getallPartnerResponse.responseContext.success) {
          this.showSearchDetails = true;
        }
        this.allPartnerData = (getallPartnerResponse.partner as Partners[]);
        this.dataSearch = (this.allPartnerData.length === 0) || false;
        this.showFrom = ((this.page - 1) * this.tableSize) + 1;
        this.showTo = Math.min(this.page * this.tableSize, this.allPartnerData.length);
        if (this.allPartnerData.length === 0) {
          this.showFrom = 0;
          this.showTo = 0;
        }
        this.displayPartnerData = [];
        this.allPartnerData.forEach(ele => {
          this.displayPartnerData.push(ele);
        });
        this.displayPartnerData.forEach(element => {
          element.isExpanded = false;
        });
      });
  }

  getAllPartnersSort(sortby: string, sortedElement, element) {
    this.partnersService.getAllPartnersInfoSortBy(sortby, sortedElement)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(getAllPartnersResponse => {
        this.allPartnerData = (getAllPartnersResponse.partner as Partners[]);
        this.displayPartnerData = [];
        this.allPartnerData.forEach(ele => {
          this.displayPartnerData.push(ele);
        });
        this.displayPartnerData.forEach(element => {
          element.isExpanded = false;
        });
        // Fix for IIT2-10086
        if (sortby === 'partnerName') {
          this.displayPartnerData.sort(function (a, b) {
            if (sortedElement === GlobalConstants.ASC_SORT) {
              element.nativeElement.setAttribute('data-order', GlobalConstants.DESC_SORT);
              return a.partnerName.localeCompare(b.partnerName, undefined, { numeric: true, sensitivity: 'base' });
            } else {
              element.nativeElement.setAttribute('data-order', GlobalConstants.ASC_SORT);
              return b.partnerName.localeCompare(a.partnerName, undefined, { numeric: true, sensitivity: 'base' });
            }
          })
        } else {
          if (sortedElement === GlobalConstants.DESC_SORT) {
            element.nativeElement.setAttribute('data-order', GlobalConstants.ASC_SORT);
          } else {
            element.nativeElement.setAttribute('data-order', GlobalConstants.DESC_SORT);
          }
        }
      });
  }

  getPartnerSoryByName(sortby, element) {
    this.getAllPartnersSort(sortby, this.partnerNameSort.nativeElement.getAttribute('data-order'), element);
  }

  getPartnerSoryByTime(sortby, element) {
    this.getAllPartnersSort(sortby, this.partnerCreatedTime.nativeElement.getAttribute('data-order'), element);
  }

  getPartnerSoryByUpdatedTime(sortby, element) {
    this.getAllPartnersSort(sortby, this.partnerUpdatedTime.nativeElement.getAttribute('data-order'), element);
  }

  clearSearch() {
    this.getAllPartnerData();
    this.animateThis.nativeElement.value = '';
    this.searchData = '';
    this.showFrom = 1;
    this.showTo = 10;
    this.page = 1;
    this.dataSearch = false;
  }

  onTableDataChange(event) {
    this.page = event;
    this.showFrom = ((this.page - 1) * this.tableSize) + 1;
    this.showTo = Math.min(this.page * this.tableSize, this.allPartnerData.length);
  }

  createPartnerForm() {
    this.partnerForm = this.formBuilder.group({
      partnerName: new FormControl(''),
      createdByName: new FormControl(''),
      configurations: new FormControl(''),
      isChromeEnabled: new FormControl('')
    });
  }

  createPublishForm() {
    this.publishMessageForm = this.formBuilder.group({
      newMessage: new FormControl(''),
      previousMessage: new FormControl(''),
      configurations: new FormControl(''),
      neverExpired: new FormControl(''),
      expiryDate: new FormControl(''),
      clearMessage: new FormControl(false)
    });
  }

  createPartner() {
    const config = {
      "imgFileName": this.imageName,
      "imgFileType": this.imageType, 
      "videoFileName": this.videoFile?.name,
      "videoFileType": this.videoFile?.type
    }
    const partnerCreation: CreatePartner = {
      partnerName: this.partnerForm.controls.partnerName.value.trim(),
      createdByName: this.partnerForm.controls.createdByName.value,
      configurations: JSON.stringify(config),
      isChromeEnabled: this.partnerForm.controls.isChromeEnabled.value ? 'Yes' : 'No'
    };
    this.partnersService.createPartner(JSON.stringify(partnerCreation))
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(createPartnerResponse => {
        this.createPartnerResponse = createPartnerResponse.partner as CreatePartner[];
        this.partnerId = createPartnerResponse.partner.partnerId;
        if (createPartnerResponse.responseContext.success) {
          this.updateMedia(this.partnerId);
          if (this.videoFile) {
            this.uploadFiles(this.videoFile, GlobalConstants.FILE_TYPE_VIDEO , this.partnerId, PartnersConstants.PARTNERVIDEO);
          }          
          this.getAllPartnerData();
          this.animateThis.nativeElement.value = '';
          this.searchData = '';
          this.openModal = false;
        }
        this.resetForm();
      }, error => {
        this.duplicatePartner = true;
      }
      );
  }

  resetForm() {
    this.partnerForm.reset();
    this.showTypeError = false;
    this.publishMessageForm.reset();
    this.videoFile = null;
    this.videoUrl = null;
  }

  imagePreview(fileInput: any, partnerId: string) {
    this.uploadEdit = true;
    this.editImageFlag = true;
    this.imageFile = fileInput.files[0];
    const reader = new FileReader();
    reader.readAsDataURL(fileInput.files[0]);
    this.fileName = this.imageFile.name;
    const fileType = this.imageFile.type.split('/')[1];
    if (this.imageFile.type.split('/')[0] === GlobalConstants.FILE_TYPE_IMAGE) {
      this.showTypeError = fileType !== GlobalConstants.CONTENT_TYPE_JPG &&
        fileType !== GlobalConstants.CONTENT_TYPE_PNG && fileType !== GlobalConstants.CONTENT_TYPE_JPEG;
      this.showSizeError = this.imageFile.size > GlobalConstants.UPLOAD_LOGO_IMAGE_SIZE_5MB;
    } else {
      this.showTypeError = true;
    }
    reader.onload = _event => {
      this.fileType = this.imageFile.type.split('/')[1];
      const index = this.displayPartnerData.findIndex(ele => ele.partnerId === partnerId);
      this.displayPartnerData[index].imageUrl = reader.result;
    };
  }

  updatePartner(id, partnerData, isChromeEnabled) {
    let isOEMChromeEnabled;
    const index = this.displayPartnerData.findIndex(ele => ele.partnerId === id);
    this.displayPartnerData[index].isExpanded = false;
    isOEMChromeEnabled = this.displayPartnerData[index].isChromeEnabled;
    let configurations: PartnerConfigurations = {};
    if (this.displayPartnerData[index]?.configurations?.includes('imgFileName')) {
      configurations = JSON.parse(this.displayPartnerData[index]?.configurations)
      if (this.fileName) {
        configurations.imgFileName = this.fileName;
        configurations.imgFileType = this.imageFile?.type;
      }
      if (this.editVideoFileName) {
        configurations.videoFileName = this.editVideoFileName;
        configurations.videoFileType = this.editVideoFileType;
      }
    } else {
      configurations.imgFileName = this.fileName ? this.fileName : this.displayPartnerData[index]?.configurations;
      configurations.imgFileType = this.imageFile?.type ? this.imageFile?.type : GlobalConstants.CONTENT_TYPE_JPG; // Todo : add imagetype
      if (this.editVideoFileName) {
        configurations.videoFileName = this.editVideoFileName;
        configurations.videoFileType = this.editVideoFileType;
      }
    }
    // IIAT-1956 end
    const updatePartnerCreation: UpdatePartner = {
      partnerName: partnerData.trim(),
      configurations: JSON.stringify(configurations),
      isChromeEnabled: isOEMChromeEnabled
    };
    this.partnersService.putPartnerById(JSON.stringify(updatePartnerCreation), id)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(updatePartnerResponse => {
        this.updatePartnerResponse = updatePartnerResponse.partner as CreatePartner[];
        if (updatePartnerResponse.responseContext.success) {
          if (this.uploadEdit) {
            if (this.imageFile) {
            this.updateImage(id,this.imageUploadedBy);
          }
            if (this.editVideoFile) {
              this.uploadFiles(this.editVideoFile, this.editVideoFile?.type, id, PartnersConstants.PARTNERVIDEO);
            }
          }
          this.getAllPartnerData();
          this.animateThis.nativeElement.value = '';
          this.searchData = '';
        }
      }, error => {
        this.duplicatePartner = true;
      }
      );
      this.videoEditFlag = false;
      this.editImageFlag = false;
  }
  oemChange(e, id) {
    const index = this.displayPartnerData.findIndex(ele => ele.partnerId === id);
    if (e.target.checked) {
      this.displayPartnerData[index].isChromeEnabled = 'Yes';
    } else {
      this.displayPartnerData[index].isChromeEnabled = 'No';
    }
  }

  cancelEdit(id: string) {
    this.buttonShow[id] = false;
    this.fileName = '';
    this.showTypeError = false;
    this.showSizeError = false;
    const index = this.displayPartnerData.findIndex(ele => ele.partnerId === id);
    if (index > -1) {
      this.displayPartnerData[index].isEdit = false;
      this.displayPartnerData[index].isExpanded = false;
    }
    this.getAllPartnerData();
    this.animateThis.nativeElement.value = '';
    this.searchData = '';
    this.videoEditFlag = false;
    this.videoFileName = '';
    this.editVideoFileName = '';
    this.editVideoLengthError = false;
    this.editFileTypeError = false;
    this.editVideoSizeError = false;
    this.editImageFlag = false;
  }

  uploadImageForCreatePartner(imageInput: any) {
    this.file = imageInput.files[0];
    const reader = new FileReader();
    reader.readAsDataURL(imageInput.files[0]);
    this.imageName = this.file.name;
    this.imageType = this.file.type;
    const fileType = this.file.type.split('/')[1];
    if (this.file.type.split('/')[0] === GlobalConstants.FILE_TYPE_IMAGE) {
      this.showTypeError = fileType !== GlobalConstants.CONTENT_TYPE_JPG &&
        fileType !== GlobalConstants.CONTENT_TYPE_PNG && fileType !== GlobalConstants.CONTENT_TYPE_JPEG;
      this.showSizeError = this.file.size > GlobalConstants.UPLOAD_LOGO_IMAGE_SIZE_5MB;
    } else {
      this.showTypeError = true;
    }
    reader.onload = _event => {
      this.imageData = reader.result;
      this.fileType = this.file.type.split('/')[1];
    };
  }

  updateMedia(id) {
    return new Promise((resolve, reject) => {
      this.partnersService.putImage(this.file, this.fileType, id,'')
        .pipe(takeUntil(this.ngUnsubscribe))
        .pipe(first())
        .subscribe(
          (data) => {
            resolve(data);//To-Do: we should handle what if response code is other than 200
          },
          error => { // do something
          }
        );
    });
  }

  updateImage(id,imageUploadedBy) {
    this.partnersService.putImage(this.imageFile, this.fileType, id, imageUploadedBy)
      .pipe(takeUntil(this.ngUnsubscribe))
      .pipe(first())
      .subscribe(
        (data) => {
        },
        error => { // do something
        }
      );
  }

  onCloseMessagePopup() {
    this.showMessagePopup = false;
    this.resetForm();
    this.isExpiredDateIncorrect = false;
    this.isCustomExpiryDateCorrect = false;
    this.isCustomExpiryTimeZoneSelected = false;
    this.isExpiryDatePicker = false;

  }
  openMessagePopup() {
    this.isclearMessage = false;
    this.isPublishDateCustomDatepicker = false;
    this.customExpiryDateResult = GlobalConstants.NEVER;
    this.showMessagePopup = true;
    this.getPreviousOEMMessage();
  }
  switchToNewMessage() {
    this.isNewWindowOpen = true;
    this.isPreviousWindowOpen = false;
    this.publishMessageForm.controls.newMessage.setValue('');
    this.customExpiryDateResult = GlobalConstants.NEVER;
    this.isPublishDateCustomDatepicker = false;
    this.isExpiryDatePicker = false;
  }
  switchToPreviousMessage() {
    this.isPreviousWindowOpen = true;
    this.isNewWindowOpen = false;
  }

  getPublishExpireDate(data) {
    this.customExpiryDateResult = this.generateDateTimeZone(data);
  }

  generateDateTimeZone(data) {
    return `${moment(data.dateVal).format(GlobalConstants.DATE_FORMAT)} ${data.hour}:${data.min} ${data.timeZone}`;
  }
  checkIfTimeset(data, check) {
    if (check === 'publish') {
      if (data[0] && data[1]) {
        this.isCustomPublishDateCorrect = false;
      }
    }
    if (data[0] && data[1]) {
      this.isCustomExpiryDateCorrect = false;
    }
  }
  checkTimeZone(data, check) {
    (check === GlobalConstants.PUBLISH) ? (this.isCustomPublishTimeZoneSelected = !data) : (this.isCustomExpiryTimeZoneSelected = !data);
  }

  getMessageExpiryDate(data) {
    this.customExpiryDateResult = this.generateDateTimeZone(data);
  }

  getPreviousOEMMessage() {
    const checkPresentDate = new Date();
    this.partnersService.getPreviousOEMMessage()
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(result => {
        let updatedTime = new Date(result?.message?.ExpirationTime);
        if (result?.message?.publishedMsg != undefined) {
          if (result?.message?.ExpirationTime !== GlobalConstants.NEVER && checkPresentDate < updatedTime) {
            this.ispreviousmessage = true;
            this.publishMessageForm.controls.previousMessage.setValue(result.message.publishedMsg);
            this.isNewWindowOpen = true;
            this.publishMessageForm.controls.newMessage.setValue('');
          } else if (result?.message?.ExpirationTime === GlobalConstants.NEVER) {
            this.ispreviousmessage = true;
            this.publishMessageForm.controls.previousMessage.setValue(result.message.publishedMsg);
            this.isNewWindowOpen = true;
            this.publishMessageForm.controls.newMessage.setValue('');
          } else {
            this.ispreviousmessage = false;
          }
          this.expiredOEMMsgTime = result.message.ExpirationTime;
          this.publishedDateTime = result.message.publishTime;
          this.publishedBy = result.message.publishedBy;
        } else {
          this.ispreviousmessage = false;
        }
      });
  }

  publishMessageToOEMPartners(payload) {
    this.partnersService.publishMessageToOEM(JSON.stringify(payload))
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(publishMessageResponse => {
        this.resetForm();
        this.acknowlegementTitle = (this.isclearMessage) ? this.messageCleared : this.messagePublished;
        this.acknowlegementDesc = (this.isclearMessage) ? this.clearMessageSuccess : this.publishMessageSuccess;
        this.openAcknowModal(this.acknowledgeModal);
      }, error => {
      }
      );
  }

  onClearMessageCheckboxChange(event) {
    this.isclearMessage = (event.target.checked) ? true : false;
  }

  onPublishMessageClick() {
    this.checkExpiryDateTime();
    this.customValidation();
    let payload;
    if (this.isclearMessage) {
      const clearMsgObj = {
        clearMessage: this.publishMessageForm.controls.clearMessage.value
      };
      payload = clearMsgObj;
      this.publishMessageForm.controls.newMessage.setValue('');
    } else {
      const publishMsgObj = {
        publishedMsg: this.publishMessageForm.controls.newMessage.value.trim(),
        ExpirationTime: (this.customExpiryDateResult === GlobalConstants.NEVER) ? GlobalConstants.NEVER : Utils.changeSaveDateFormat(this.customExpiryDateResult),
      };
      payload = publishMsgObj;
    }
    if (!this.isExpiredDateIncorrect && !this.isCustomExpiryDateCorrect && !this.isCustomExpiryTimeZoneSelected) {
      this.onCloseMessagePopup();
      this.publishMessageToOEMPartners(payload);
    }
  }

  checkStatus(status) {
    return (status === GlobalConstants.CUSTOM);
  }
  selectCustomPublishMessageDate(datetimeOption) {
    this.isPublishDateCustomDatepicker = this.checkStatus(datetimeOption);
    if (!this.isPublishDateCustomDatepicker && this.customPublishDateResult !== GlobalConstants.NOW) {
      this.customPublishDateResult = Utils.getCurrentDate();
    }
    if (datetimeOption === GlobalConstants.NOW) {
      this.isCustomPublishDateCorrect = false;
      this.isCustomPublishTimeZoneSelected = false;
    }
  }
  checkPublishedDateTime() {
    this.isSubmitted = false;
    const today = new Date();
    let isPublishedDateSmaller;
    if (this.segmentsForm.controls.publishedTimeStamp.toString() !== '') {
      isPublishedDateSmaller = new Date(this.segmentsForm.controls.publishedTimeStamp.value).getTime() < new Date().getTime();
    }
    this.isPublishedDateInCorrect = isPublishedDateSmaller;
  }
  checkExpiryDateTime() {
    if (this.customExpiryDateResult !== GlobalConstants.NEVER) {
      this.isExpiredDateIncorrect = Utils.customDateCheck(this.customPublishDateResult, this.customExpiryDateResult);
    }
  }
  selectExpiryDateTimeZone(datetimeOption) {
    this.isExpiryDatePicker = this.checkStatus(datetimeOption);
    if (this.isExpiryDatePicker && this.editexpiryDateInfo) {
      this.customExpiryDateResult = this.editexpiryDateInfo;
    }
    if (!this.isExpiryDatePicker && this.customExpiryDateResult !== GlobalConstants.NEVER) {
      this.customExpiryDateResult = GlobalConstants.NEVER;
    }
    if (datetimeOption === GlobalConstants.NEVER) {
      this.isExpiredDateIncorrect = false;
      this.isCustomExpiryDateCorrect = false;
      this.isCustomExpiryTimeZoneSelected = false;
    }
  }
  customValidation() {
    if (this.isPublishDateCustomDatepicker) {
      this.isCustomPublishDateCorrect = (this.customPublishDateResult === GlobalConstants.NOW);
    }
    if (this.isExpiryDatePicker) {
      this.isCustomExpiryDateCorrect = (this.customExpiryDateResult === GlobalConstants.NEVER);
    }
  }
  tabChange() {
    this.isUploadLogoTabActive = !this.isUploadLogoTabActive;
  }

  onVideoUpload(data) {
    this.isVideoTriggered = true;
    this.videoFile = data.target.files[0];
    const reader = new FileReader();
    const fileType: string = this.videoFile?.type;
    const fileSize: number = this.videoFile?.size;
    this.fileTypeError = fileType !== GlobalConstants.FILE_TYPE_VIDEO_MP4;
    this.videoSizeError = fileSize > GlobalConstants.UPLOAD_VIDEO_MAX_SIZE;
    this.isVideo = !(this.fileTypeError || this.videoSizeError);
    if (!this.fileTypeError) {
      reader.readAsDataURL(this.videoFile);
      reader.onload = _event => {
        let video = document.createElement('video');
        video.preload = 'metadata';
        video.src = _event.target.result.toString();
        video.onloadedmetadata = () => {
          this.videoLengthError = video.duration > GlobalConstants.UPLOAD_VIDEO_MAX_TIME;
          this.isVideo = !(this.fileTypeError || this.videoSizeError || this.videoLengthError);
          if (this.isVideo) {
            this.videoUrl = this.sanitizer.bypassSecurityTrustUrl(URL.createObjectURL(this.videoFile));
          }
        }
      }
    }
  }

  uploadFiles(file, fileType, partnerId, fileFor) {
    return new Promise((resolve, reject) => {
      this.partnersService.putImageVideoFiles(file, fileType, partnerId, fileFor)
        .pipe(takeUntil(this.ngUnsubscribe))
        .pipe(first())
        .subscribe((data) => {
          resolve(data);
        },
          error => { // do something
          });
    });

  }

  videoPreview(fileInput: any, partnerId: string) {
    this.uploadEdit = true;
    this.videoEditFlag = true;
    this.editVideoFile = fileInput.files[0];
    const reader = new FileReader();
    this.editVideoFileName = this.editVideoFile?.name;
    this.editVideoFileType = this.editVideoFile?.type;
    const fileSize: number = this.editVideoFile?.size;
    this.editFileTypeError = this.editVideoFileType !== GlobalConstants.FILE_TYPE_VIDEO_MP4;
    this.editVideoSizeError = fileSize > GlobalConstants.UPLOAD_VIDEO_MAX_SIZE;
    if (!this.editFileTypeError) {
      reader.readAsDataURL(this.editVideoFile);
      reader.onload = _event => {
        let video = document.createElement('video');
        video.preload = 'metadata';
        video.src = _event.target.result.toString();
        video.onloadedmetadata = () => {
          this.videoLengthError = video.duration > GlobalConstants.UPLOAD_VIDEO_MAX_TIME;
          this.isVideo = !(this.editFileTypeError || this.editVideoSizeError || this.videoLengthError);
          if (this.isVideo) {
            this.videoUrl = this.sanitizer.bypassSecurityTrustUrl(URL.createObjectURL(this.videoFile));
          }
        }
      }
    }
    reader.onload = _event => {
      const index = this.displayPartnerData.findIndex(ele => ele.partnerId === partnerId);
      this.displayPartnerData[index].videoUrl = reader.result;
    };
  }
}
